module.exports = __webpack_public_path__ + "static/media/mn18.8a5a69ea.jpeg";